module.exports = __webpack_public_path__ + "static/media/ET188-A new.d361e1f5.jpg";